/* eslint-disable max-len */
import React, { memo } from 'react';
import proptypes from 'prop-types';
const { shape, string, bool } = proptypes;
import { Image } from '@thd-olt-component-react/core-ui';
import { click } from './events';
import { useImpression } from '@thd-olt-component-react/impression';

import './zone-card.scss';

const InstallZoneCard = ({ major = false, header, details, componentPosition, category }) => {

  const { title, description: headerDescription } = header;
  const { description: detailsDescription, link, imageUrl, recordType } = details;

  const { ref, clickID } = useImpression({
    data: {
      id: "00DEFVALCC00",
      name: 'CategoryCards',
      component: 'CategoryCards',
      position: componentPosition,
      type: 'content',
      category: category
    }
  });

  return (
    <>
      {major
        ? (
          <section className="zone-card__zone1" ref={ref} clickid={clickID}>
            <div className="zone-card__serviceheader-wrapper">
              <div className="zone-card__serviceheader-zone1">
                <h2 className="zone-card__header u__bold">{title}</h2>
                <p className="zone-card__header-text">{headerDescription}</p>
              </div>
              <div className="zone-card__serviceheader-zone2">
                <span className={recordType?.includes('Services:')
                  ? 'zone-card__serviceslogo'
                  : 'zone-card__pro-referral-logo'}
                />
              </div>
            </div>
            <div className="zone-card-details zone-card-servicedetails">
              <div className="zone-card-details__bigimage">
                <Image src={imageUrl} alt="" stretchy width="1" height="1" />
              </div>
              <div className="zone-card-details__description zone-card-details__smallcontent">
                <div className="zone-card-details__text zone-card-details__servicestext category-cards-details__text--truncate">
                  {detailsDescription}
                </div>
                <div className="zone-card-details__actions">
                  <a
                    className="bttn-outline bttn-outline--primary bttn--inline zone-card-details__btn"
                    href={link}
                    onClick={() => {
                      click({
                        pageNumber: 1,
                        position: 'r1',
                        type: title
                      });
                    }}
                  >
                    <span className="bttn__content">Learn More</span>
                  </a>
                </div>
              </div>
            </div>
          </section>
        )
        : (
          <section className="zone-card__zone2">
            <div className="zone-card__serviceheader-wrapper">
              <div className="zone-card__serviceheader-zone1">
                <h2 className="u__truncate zone-card__header u__bold">{title}</h2>
                <p className="zone-card__header-text">{headerDescription}</p>
              </div>
              <div className="zone-card__serviceheader-zone2">
                <span className="zone-card__serviceslogo" />
              </div>
            </div>
            <div className="zone-card-details__bigimage">
              <Image src={details.imageUrl} alt="" stretchy width="1" height="1" />
            </div>
            <div>
              <a
                className="zone-card__video-link"
                href={link}
                onClick={() => {
                  click({
                    pageNumber: 1,
                    position: 'r1',
                    type: title
                  });
                }}
              >
                Learn More
              </a>
            </div>
          </section>
        )}
    </>
  );
};

InstallZoneCard.displayName = 'CategoryCards-InstallZoneCard';

InstallZoneCard.propTypes = {
  header: shape({
    title: string,
    description: string
  }).isRequired,
  details: shape({
    imageUrl: string,
    description: string,
    link: string
  }).isRequired,
  major: bool
};

const MemoInstallZoneCard = memo(InstallZoneCard);

export { MemoInstallZoneCard as InstallZoneCard };
